import Domain from "./domain";
export default {
  methods: {
    queryBuilder: function() {
      let query = [];
      query.push("attendance_type=in");
      query.push("from_date=2019-09-15");
      query.push("to_date=2019-09-26");
      query.push("page=0");
      query.push("perpage=10");
      return query.length > 0 ? query.join("&") : "";
    },
    emergencyList: async function(holder_type = "visitor") {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN +
            "customer/attendance/details/emergency?holder_type=" +
            holder_type +
            "&page=0&perpage=500",
          Domain.APP_HEADER
        );
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    signIn: async function(date, type) {
      let toDate = new Date(
        new Date(date).setDate(new Date(date).getDate() + 1)
      )
        .toISOString()
        .split("T")[0];

      let url =
        Domain.APP_DOMAIN +
        "customer/attendance/details?attendance_type=in&from_date=" +
        date +
        "&to_date=" +
        toDate;
      if (type) {
        url = url + "&holder_type=" + type;
      }
      try {
        let response = await this.axios.get(url, Domain.APP_HEADER);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    signOut: async function(date, type) {
      let url =
        Domain.APP_DOMAIN +
        "customer/attendance/details?attendance_type=out&from_date=" +
        date +
        "&to_date=" +
        date;
      if (type) {
        url = url + "&holder_type=" + type;
      }
      try {
        let response = await this.axios.get(url, Domain.APP_HEADER);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    //http://tv.persystance.com:3015/api/v1/customer/attendance/details/search
    // ?company=&holder_type=&attendance_type=&from_date=2019-08-12&to_date=2019-09-13&page=0&perpage=20&id=&first_name=nim&last_name=&mobile=&key=&class='
    filterList: async function(options) {
      try {
        let url = "customer/attendance/details/search";
        if (options && options.length > 0) {
          let params = options.join("&");
          url = url + "?" + params;
        }

        let response = await this.axios.get(
          Domain.APP_DOMAIN + url,
          Domain.APP_HEADER
        );
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    errorsLog: async function() {
      try {
        let url = "customer/error/attendance/details";
        let response = await this.axios.get(
          Domain.APP_DOMAIN + url,
          Domain.APP_HEADER
        );
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    historicalList: async function(htype, logType, to, from) {
      try {
        if (logType == null) {
          let response = await this.axios.get(
            Domain.APP_DOMAIN +
              "customer/attendance/details?&holder_type=" +
              htype +
              "&from_date=" +
              to +
              "&to_date=" +
              from +
              "&page=0&perpage=10000",
            Domain.APP_HEADER
          );
          return response.data;
        } else {
          let response = await this.axios.get(
            Domain.APP_DOMAIN +
              "customer/attendance/details?&holder_type=" +
              htype +
              "&attendance_type=" +
              logType +
              "&from_date=" +
              to +
              "&to_date=" +
              from +
              "&page=0&perpage=10000",
            Domain.APP_HEADER
          );
          return response.data;
        }
      } catch (error) {
        throw error;
      }
    },
    historicalListUserName: async function(
      htype,
      logType,
      to,
      from,
      fname,
      lname
    ) {
      try {
        if (logType === "null") {
          let response = await this.axios.get(
            Domain.APP_DOMAIN +
              "customer/attendance/details?&holder_type=" +
              htype +
              "&from_date=" +
              to +
              "&to_date=" +
              from +
              "&first_name=" +
              fname +
              "&last_name=" +
              lname +
              "&page=0&perpage=10000",
            Domain.APP_HEADER
          );
          return response.data;
        } else {
          let response = await this.axios.get(
            Domain.APP_DOMAIN +
              "customer/attendance/details?&holder_type=" +
              htype +
              "&attendance_type=" +
              logType +
              "&from_date=" +
              to +
              "&to_date=" +
              from +
              "&first_name=" +
              fname +
              "&last_name=" +
              lname +
              "&page=0&perpage=10000",
            Domain.APP_HEADER
          );
          return response.data;
        }
      } catch (error) {
        throw error;
      }
    },
    historicalListChangeClass: async function(
      htype,
      logType,
      to,
      from,
      classId
    ) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN +
            "customer/attendance/details?&holder_type=" +
            htype +
            "&attendance_type=" +
            logType +
            "&from_date=" +
            to +
            "&to_date=" +
            from +
            "&class=" +
            classId,
          Domain.APP_HEADER
        );
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    geHistoricalListById: async function(id, htype) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN +
            "customer/attendance/details?&holder_type=" +
            htype +
            "&id=" +
            id +
            "&page=0&perpage=1000",
          Domain.APP_HEADER
        );
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    getSignedInById: async function(id) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN +
            "customer/attendance/details?&attendance_type=in" +
            "&id=" +
            id +
            "&page=0&perpage=1000",
          Domain.APP_HEADER
        );
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    getSignedOutById: async function(id) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN +
            "customer/attendance/details?&attendance_type=out" +
            "&id=" +
            id +
            "&page=0&perpage=1000",
          Domain.APP_HEADER
        );
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    deleteHisRecord: async function(id) {
      try {
        let response = await this.axios.delete(
          Domain.APP_DOMAIN + "customer/attendance/" + id,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    putAttendence: async function(obj) {
      try {
        let response = await this.axios.put(
          Domain.APP_DOMAIN + "customer/attendance",
          obj,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    exportCSVReport: async function(fdate, tdate, holder, loginType) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN +
            "customer/attendance/details/download?holder_type=" +
            holder +
            "&attendance_type=" +
            loginType +
            "&from_date=" +
            fdate +
            "&to_date=" +
            tdate +
            "&type=1",
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    exportCSVReportWithName: async function(
      fdate,
      tdate,
      holder,
      loginType,
      fname,
      lname
    ) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN +
            "customer/attendance/details/download?holder_type=" +
            holder +
            "&attendance_type=" +
            loginType +
            "&from_date=" +
            fdate +
            "&to_date=" +
            tdate +
            "&type=1" +
            "&first_name=" +
            fname +
            "&last_name=" +
            lname,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    exportEXCELReport: async function(fdate, tdate, holder, loginType) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN +
            "customer/attendance/details/download?holder_type=" +
            holder +
            "&attendance_type=" +
            loginType +
            "&from_date=" +
            fdate +
            "&to_date=" +
            tdate +
            "&type=2",
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    exportEXCELReportWithName: async function(
      fdate,
      tdate,
      holder,
      loginType,
      fname,
      lname
    ) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN +
            "customer/attendance/details/download?holder_type=" +
            holder +
            "&attendance_type=" +
            loginType +
            "&from_date=" +
            fdate +
            "&to_date=" +
            tdate +
            "&type=2" +
            "&first_name=" +
            fname +
            "&last_name=" +
            lname,
          Domain.APP_HEADER
        );
        console.log("res");
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    putInToSignout: async function(obj) {
      try {
        let response = await this.axios.put(
          Domain.APP_DOMAIN + "customer/attendance/signout",
          obj,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    putSignIn: async function(obj) {
      try {
        let response = await this.axios.put(
          Domain.APP_DOMAIN + "customer/attendance",
          obj,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    postAttendance: async function(contact, type, obj) {
      let url = Domain.APP_DOMAIN + "customer/attendance/" + type;
      if (contact === "visitor" || contact === "contractor") {
        if (type === "signout") {
          url = Domain.APP_DOMAIN + "customer/attendance/" + type;
        } else {
          url =
            Domain.APP_DOMAIN + "customer/attendance/" + contact + "/" + type;
        }
      } else {
        url = Domain.APP_DOMAIN + "customer/attendance/" + type;
      }
      try {
        let response = await this.axios.post(url, obj, Domain.APP_HEADER);
        if (!response || !response.data) {
          throw Error("Failed to process, Check the details before procceed.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    }
  }
};
